module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    class: _vm.isActive ? 'active' : '',
    attrs: {
      "href": _vm.href
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-459274dc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/breadcrumb_item.vue
// module id = 1216
// module chunks = 1